import { render, staticRenderFns } from "./Smalls.vue?vue&type=template&id=b40d5e58&"
import script from "./Smalls.vue?vue&type=script&lang=js&"
export * from "./Smalls.vue?vue&type=script&lang=js&"
import style0 from "./Smalls.vue?vue&type=style&index=0&id=b40d5e58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports